import { FeeMarketEIP1559Transaction, Transaction as LegacyTransaction, } from '@exodus/ethereumjs-tx';
export function getTransactionId(serializedTransaction, isEIP1559Transaction = false) {
    const Transaction = isEIP1559Transaction
        ? FeeMarketEIP1559Transaction
        : LegacyTransaction;
    const transaction = Transaction.fromSerializedTx(serializedTransaction);
    return `0x${transaction.hash().toString('hex')}`;
}
export function getDisplayDetails(willApprove) {
    let title = 'Approve Transaction?';
    const isApproveTransaction = willApprove.length;
    if (isApproveTransaction) {
        const tokenName = willApprove[0].unitName;
        // Don't change the title if 'tokenName' is undefined
        title = tokenName ? `Approve ${tokenName} Transactions?` : title;
    }
    return { title };
}
export const getTxFeeDetails = (transaction) => {
    const maxFeePerGas = transaction.maxFeePerGas;
    const gasPrice = transaction.gasPrice;
    const gasLimit = transaction.gas;
    return {
        gasLimit,
        maxFeePerGas,
        gasPrice,
    };
};
